import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import apiHelperService from '@/services'

const checkElgibleForEidaRefundApi = async () => {
  const formStore = useFormStore()

  const { applicantInformationType } = formStore.extraMap

  const { refundReasonCategoryIds, exemptReasonCategoryIds, referenceRequestNumber } =
    formStore.form.values
  const params = {
    refundReasonCategoryIds,
    exemptReasonCategoryIds,
    referenceRequestNumber,
    applicantInformationType: applicantInformationType
  }
  const res = await apiHelperService.get(`/api/icaRequest/draft/checkElgibleForEidaRefund`, {
    params
  })
  return res
}

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

export default async function () {
  const formStore = useFormStore()
  const authStore = useAuthStore()

  const reasonCategoriesAutoComplete =
    formStore.draft?.request.reasonCategoriesAutoComplete ||
    formStore.form.values.reasonCategoriesAutoComplete
  const exemptReasonCategoriesAutoComplete =
    formStore.draft?.request.exemptReasonCategoriesAutoComplete ||
    formStore.form.values.exemptReasonCategoriesAutoComplete

  const isValidateTypingCenterOtp =
    authStore.isUserTypingCenter &&
    authStore.isUserServiceCenter &&
    formStore.extraMap.aplicantInformationType == lookups.eidaRefundApplicantInformationType.otp &&
    !formStore.draft?.request.isVerifiedOtp

  if (isValidateTypingCenterOtp) {
    doNotify(i18n.global.t('checkOtpVerification'), i18n.global.t('checkOtpVerification'))
    return false
  }

  if (reasonCategoriesAutoComplete.length == 0) {
    doNotify(
      i18n.global.t('refundReasonCategoriesMissing'),
      i18n.global.t('refundReasonCategoriesMissing')
    )
    return false
  }

  // if is rejected then the reason should equal to 711
  if (
    formStore.extraMap.isRejectedEidaRequest &&
    reasonCategoriesAutoComplete?.length == 1 &&
    reasonCategoriesAutoComplete?.includes?.('711')
  ) {
    doNotify(
      i18n.global.t('shouldChooseReasonOfReject'),
      i18n.global.t('shouldChooseReasonOfReject')
    )
    return false
  }

  if (
    reasonCategoriesAutoComplete.includes('713') &&
    exemptReasonCategoriesAutoComplete?.length <= 0
  ) {
    doNotify(i18n.global.t('exemptionDetailsMissing'), i18n.global.t('exemptionDetailsMissing'))
    return false
  }

  if (reasonCategoriesAutoComplete.includes('711')) {
    doNotify(
      i18n.global.t('IDcardRequestRejectedRefundReason'),
      i18n.global.t('IDcardRequestRejectedRefundReason')
    )
    return false
  }

  if (!formStore.draft?.isInCompleteDraftFlag) {
    const res = await checkElgibleForEidaRefundApi()
    if (res && res.length > 0) {
      return false
    }
  }
  return true
}
